import { TypeRequest } from "../common/enums/AllEnums";
import INewPassword from "../interfaces/INewPassword";
import IReportProblem from "../interfaces/IReportProblem";
import { IResponse } from "../interfaces/IResponse";
import { IUserSession } from "../interfaces/IUser";
import { BisAPI, BisApiRequest } from "./apis";

export const SignIn = (user: IUserSession): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest('/Proyecto/IniciarSesion', TypeRequest.post, user).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}


export const SignOut = (): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest('/Proyecto/CerrarSesion', TypeRequest.put).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}


export const ChangePassword = (newPassword: INewPassword): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest('/Proyecto/CambiarContrasena', TypeRequest.put, newPassword).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}


export const ReportProblem = (problem: IReportProblem): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest('/Proyecto/ReportarProblema', TypeRequest.post, problem).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}